import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  authActions,
  alertActions,
  WhitelabelActions,
} from "../../store/actions";
import { history } from "../../helpers";
import "../../static/css/styles.css";
import { validationEmail } from "../../helpers/response";
import Footer from "../../components/Footer/footer";
import { Spring } from "react-spring";
import { constants } from "../../Constants";
import saayaLogo from "../../static/images/saaya_logo.png";
import { patientRegister } from "../../helpers/ConstantID";
import defaultImage from "../../static/images/default_BG.png";

class Register extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email_domain: "@khi.iba.edu.pk",
      onboardingEmail: "",
      user: {
        role: "1",
        full_name: "",
        isRedirectedUser: false,
        password1: "",
        password2: "",
        checkbox: false,
        is_mobile: false,
        subsidiary_name: "",
        email_address: "",
        employee_id: "",
        error_name: false,
        error_fname: false,
        error_pwd: false,
        error_cpwd: false,
        error_subsidiary: false,
        error_email: false,
      },
      submitted: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRadioButton = this.handleRadioButton.bind(this);
  }
  componentWillMount() {
    this.props.fetchWhitelabel();
  }

  componentDidMount() {
    window.innerWidth <= 700
      ? this.setState({ is_mobile: true })
      : this.setState({ is_mobile: false });
    const { whitelabel } = this.props;
    if (localStorage.getItem("onboarding_email")) {
      const onboardingEmail = localStorage.getItem("onboarding_email");
      const subDomain = whitelabel && whitelabel[0].sub_domain.toLowerCase();
      if (
        subDomain.toLowerCase().indexOf(constants.PAKQATAR.toLowerCase()) > -1
      ) {
        let user = this.state.user;
        user.email_address = onboardingEmail;
        this.setState({
          isRedirectedUser: true,
          email_address: onboardingEmail,
          user: user,
        });
      }
    }
    // clear alert on location change
    this.props.clearAlertActions();
  }

  handleChange(ev) {
    const { name, value } = ev.target;
    const { user } = this.state;
    this.setState({
      user: {
        ...user,
        [name]: name === 'checkbox' ? ev.target.checked : value,
      },
    });
    this.validationOnChange(name, value)
  }

  validationOnChange = (field, value) => {
    const { user } = this.state;
    if (field === 'full_name') {
      this.setState({
        error_name: false
      })
    }
    else if (field === 'email_address') {
      this.setState({
        error_email: false
      })
      if (!validationEmail(value)) {
        this.setState({
          error_email: true
        })
      }
      else if (this.validateEmail) {
        this.setState({
          error_email: false
        })
      }
    }
    else if (field === 'subsidiary_name') {
      this.setState({
        error_subsidiary: false
      })
    }
    else if (field === 'employee_id') {
      this.setState({
        error_employee_id: false
      })
    }
    else if (field === 'password1') {
      this.setState({
        error_pwd: false
      })
    }
    else if (field === 'password2') {
      this.setState({
        error_cpwd: false
      })
    }
    this.props.alertError("");
  }

  componentWillUnmount() {
    if (localStorage.getItem("onboarding_email")) {
      localStorage.removeItem("onboarding_email");
    }
  }

  handleRadioButton(e) {
    this.setState({ email_domain: e.target.value });
  }

  parseEmailDomains() {
    var str = this.props.whitelabel[0].email_domain;
    str = str.replace(/[\[\]']+/g, "");
    str = str.replace(/\s+/g, "");
    var email_domains_array = str.split(",");
    return email_domains_array;
  }

  getUserEmailDomain() {
    const { email_address } = this.state.user;

    if (validationEmail(email_address)) {
      var email_domain = email_address.split("@")[1];
      return email_domain;
    }
  }

  validateEmail() {
    var userInput = this.getUserEmailDomain();
    var parsedEmails = this.parseEmailDomains();
    for (var i = 0; i < parsedEmails.length; i++) {
      if (userInput === parsedEmails[i] || parsedEmails[i] === "all") {
        return true;
      }
    }
    return false;
  }

  handleSubmit(ev) {
    const { whitelabel } = this.props;
    ev.preventDefault();
    this.setState({ submitted: true });
    const { user } = this.state;
    user.project = whitelabel && whitelabel[0].name;
    const verificationRequired = !!(
      whitelabel &&
      whitelabel[0] &&
      whitelabel[0].is_employee_id_verification_required
    );
    const employeeIdComplete =
      !verificationRequired ||
      (user.employee_id && user.employee_id.trim().length > 0);
    const payload = { ...user };
    if (!verificationRequired) {
      delete payload.employee_id;
    }

    if (!validationEmail(user.email_address)) {
      if (
        user.role === '' ||
        user.full_name === '' ||
        user.password1 === '' ||
        user.password2 === '' ||
        user.email_address === '' ||
        user.subsidiary_name === '' ||
        !employeeIdComplete
      ) {
        this.setState({
          error_name: user.full_name === '' ? true : false,
          error_fname: user.full_name === '' ? true : false,
          error_pwd: user.password1 === '' ? true : false,
          error_cpwd: user.password2 === '' ? true : false,
          error_subsidiary: user.subsidiary_name === '' ? true : false,
          error_email: user.email_address === '' ? true : false,
          error_employee_id: !employeeIdComplete,
        });
        this.props.alertError(constants.FILL_ALL_FIELDS_MSG)
      }
      else {
        this.setState({
          error_name: false,
          error_fname: false,
          error_pwd: false,
          error_cpwd: false,
          error_subsidiary: false,
            error_email: true,
            error_employee_id: false,
        });
        this.props.alertError(constants.EMAIL_VALIDATION_MSG);
      }
    }
    else if (this.validateEmail()) {
      if (
        user.role &&
        user.full_name &&
        user.password1 &&
        user.password2 &&
        user.email_address &&
        user.subsidiary_name &&
        employeeIdComplete
      ) {
        if (user.password1 !== user.password2) {
          this.setState({
            error_name: false,
            error_fname: false,
            error_pwd: true,
            error_cpwd: true,
            error_subsidiary: false,
            error_email: false,
            error_employee_id: false,
          });
          this.props.alertError(constants.PASSWORD_DONOT_MATCH_MSG);
        } else if (user.checkbox) {
          this.setState({
            error_name: false,
            error_fname: false,
            error_pwd: false,
            error_cpwd: false,
            error_subsidiary: false,
            error_email: false,
            error_employee_id: false,
          });
          this.props.registerUser(payload);
        } else {
          this.setState({
            error_name: false,
            error_fname: false,
            error_pwd: false,
            error_cpwd: false,
            error_subsidiary: false,
            error_email: false,
            error_employee_id: false,
          });
          this.props.alertError(constants.TERMS_CONDITIONS_MSG);
        }
      } else {
        this.setState({
          error_name: user.full_name === '' ? true : false,
          error_fname: user.full_name === '' ? true : false,
          error_pwd: user.password1 === '' ? true : false,
          error_cpwd: user.password2 === '' ? true : false,
          error_subsidiary: user.subsidiary_name === '' ? true : false,
          error_email: user.email_address === '' ? true : false,
          error_employee_id: !employeeIdComplete,
        });
        this.props.alertError(constants.FILL_ALL_FIELDS_MSG);
      }
    } else {
      this.props.alertError(
        `${constants.PLEASE_TXT} ${constants.ENTER_YOU_EMAIL.replace(
          "{0}",
          whitelabel &&
            whitelabel[0].name &&
            whitelabel[0].name.toLowerCase() !==
            constants.PAKQATAR.toLowerCase()
            ? whitelabel[0].name
            : constants.REGISTERED
        )}`
      );
    }
  }

  onLogin = () => {
    history.replace("/");
  };
  render() {
    const { alert, whitelabel } = this.props;
    const {
      email_address,
      isRedirectedUser,
      error_cpwd,
      error_email,
      error_name,
      error_pwd,
      error_subsidiary,
      error_employee_id,
    } = this.state;
    const showError = alert.message && alert.message.length > 0;
    const verificationRequired = !!(
      whitelabel &&
      whitelabel[0] &&
      whitelabel[0].is_employee_id_verification_required
    );

    const OTHERS = "Others";
    let sortedWhiteLabel =
      whitelabel && whitelabel[1].sort().filter((e) => e !== OTHERS);
    whitelabel &&
      whitelabel[0].name === "B2C" &&
      sortedWhiteLabel &&
      sortedWhiteLabel.push(OTHERS);
    let options =
      whitelabel && whitelabel.length > 1 && whitelabel[1] ? (
        sortedWhiteLabel.map((s) => {
          return <option value={s}>{s}</option>;
        })
      ) : (
        <option>{constants.NO_SUBSIDIARY_TXT}</option>
      );

    if (whitelabel && whitelabel.length > 1)
      options.unshift(
        <option value="" hidden disabled selected>
          {whitelabel[0].payment_required ? "" : ""}
        </option>
      );

    const subsidiaries = options;
    return (
      <Fragment>
        <div className='sh-login-header'>
          <div><a target={"_blank"} href='https://saayahealth.com/blog'>{constants.VIEW_BLOGS}</a></div>
          <div><a href='/faq'>{constants.FAQ_TXT}</a></div>
        </div>
        <div className="sh-layout">
          <div className="sh-patient-register-comp">
            <div className="sh-gnrl-inner">
              <div className="sh-gnrl-logo">
                <img
                  src={whitelabel ? whitelabel[0].logo_url : defaultImage}
                  alt="logo"
                  id={patientRegister.sh_pr_logo}
                />
              </div>
              <div className="sh-prc-heading">
                <h2 className="sh-prc-h2" id={patientRegister.sh_pr_text1}>
                  {constants.CREATE_ACCOUNT}
                </h2>
                <p
                  className="sh-prc-gnrl-text sh-mb-20"
                  id={patientRegister.sh_pr_text2}
                >
                  Sign up to join with people who
                  <br />
                  already feel happier.
                </p>
              </div>
              <div className="sh-prc-form">
                <div className="sh-gnrl-row sh-mb-15">
                  <div className="sh-input-group">
                    <input
                      autoComplete="off"
                      id={patientRegister.sh_pr_name}
                      value={this.state.user.full_name || ""}
                      required
                      type="text"
                      name="full_name"
                      onChange={this.handleChange}
                      className={`sh-input-text ${error_name ? "sh-input-error" : ""
                        }`}
                    />
                    <label
                      htmlFor={patientRegister.sh_pr_name}
                      className="sh-input-label"
                    >
                      {constants.NAME}
                    </label>
                  </div>
                </div>

                <div className="sh-gnrl-row sh-mb-15">
                  <div className="sh-input-group">
                    <input
                      autoComplete="off"
                      id={patientRegister.sh_pr_email}
                      value={this.state.user.email_address || ""}
                      required
                      type="email"
                      name="email_address"
                      onChange={this.handleChange}
                      className={`sh-input-text ${error_email ? "sh-input-error" : ""
                        } ${this.state.user.email_address && "sh-input-active"}`}
                    />
                    <label
                      htmlFor={patientRegister.sh_pr_email}
                      className="sh-input-label"
                    >
                      {constants.EMAIL_ADDRESS}
                    </label>
                  </div>
                </div>

                {verificationRequired && (
                <div className="sh-gnrl-row sh-mb-15">
                  <div className="sh-input-group">
                    <input
                      autoComplete="off"
                      id={patientRegister.sh_pr_employee_id}
                      value={this.state.user.employee_id || ""}
                      required
                      type="text"
                      name="employee_id"
                      onChange={this.handleChange}
                      className={`sh-input-text ${error_employee_id ? "sh-input-error" : ""
                        }`}
                    />
                    <label
                      htmlFor={patientRegister.sh_pr_employee_id}
                      className="sh-input-label"
                    >
                      {constants.EMPLOYEE_ID_TXT}
                    </label>
                  </div>
                </div>
                )}

                <div className="sh-gnrl-row sh-mb-15">
                  <div className="sh-input-group sh-select-icon">
                    <select
                      required
                      className={`sh-gnrl-select ${error_subsidiary ? "sh-input-error" : ""
                        }`}
                      id={patientRegister.sh_pr_age}
                      name="subsidiary_name"
                      onChange={this.handleChange}
                      value={this.state.subsidiary_name}
                    >
                      {subsidiaries}
                    </select>
                    <label
                      htmlFor={patientRegister.sh_pr_age}
                      className="sh-select-label"
                    >
                      {whitelabel &&
                        whitelabel.length &&
                        whitelabel[0].payment_required
                        ? constants.LIST_OF_COUNTRIES_TXT
                        : constants.SUBSIDIARY_PLACEHOLDER_TXT}
                    </label>
                  </div>
                </div>

                <div className="sh-gnrl-row sh-mb-15">
                  <div className="sh-input-group">
                    <input
                      autoComplete="off"
                      id={patientRegister.sh_pr_pass}
                      required
                      type="password"
                      className={`sh-input-text ${error_pwd ? "sh-input-error" : ""
                        }`}
                      name="password1"
                      onChange={this.handleChange}
                    />
                    <label
                      htmlFor={patientRegister.sh_pr_pass}
                      className="sh-input-label"
                    >
                      {constants.ENTER_PASSWORD}
                    </label>
                  </div>
                </div>

                <div className="sh-gnrl-row sh-mb-5">
                  <div className="sh-input-group">
                    <input
                      autoComplete="off"
                      id={patientRegister.sh_pr_c_pass}
                      required
                      type="password"
                      className={`sh-input-text ${error_cpwd ? "sh-input-error" : ""
                        }`}
                      name="password2"
                      onChange={this.handleChange}
                    />
                    <label
                      htmlFor={patientRegister.sh_pr_c_pass}
                      className="sh-input-label"
                    >
                      {constants.CONFIRM_PASSWORD}
                    </label>
                  </div>
                </div>

                <div className="sh-grnl-row sh-mb-10">
                  <span className="sh-gnrl-error-msg" id={"sh_error_message"}>
                    {alert.message}
                  </span>
                </div>

                <div className="sh-gnrl-row sh-dflex sh-mb-15">
                  <div className="sh-prc-remember">
                    <div className="sh-gnrl-checkbox">
                      <input
                        type="checkbox"
                        id={patientRegister.sh_pr_term_cond}
                        name="checkbox"
                        className="chkBox"
                        onChange={this.handleChange}
                      />
                    </div>
                    <label
                      className="sh-gnrl-checkbox-label"
                      htmlFor={patientRegister.sh_pr_term_cond}
                    >
                      By checking this, you agree to our{" "}
                      <span>
                        <a href="/tandc">Terms & Condition</a>
                      </span>
                    </label>
                  </div>
                </div>

                <div className="sh-gnrl-row sh-mb-15">
                  <button
                    id={patientRegister.sh_pr_sign_in_btn}
                    className="sh-gnrl-btn sh-login-btn"
                    onClick={this.handleSubmit}
                  >
                    {constants.REGISTER}
                  </button>
                </div>

                <div className="sh-gnrl-row sh-mb-15">
                  <label
                    htmlFor={patientRegister.sh_pr_login_redirect_btn}
                    className="sh-prc-cnslr"
                  >
                    {constants.SIGN_IN_MSG.replace(
                      "{0}",
                      whitelabel && whitelabel[0]
                        ? whitelabel[0].producer_role
                        : constants.COUNSELLOR
                    )}
                    <span className="sh-color-counsellor">Sign In here</span>
                  </label>
                  <button
                    className="sh-prc-cnslr-btn"
                    onClick={this.onLogin}
                    id={patientRegister.sh_pr_login_redirect_btn}
                  ></button>
                </div>
                <div className="sh-gnrl-row sh-mb-15 blog-faq-block">
                  <label
                    className="sh-prc-cnslr"
                  >
                    {constants.FAQ_TEXT}
                    <a href="/faq"><span className="sh-color-counsellor"> {constants.CLICK_HERE_TXT}</span></a>
                  </label>
                </div>
                
                <div className="sh-gnrl-row sh-mb-15 blog-faq-block">
									<label className="sh-prc-cnslr">
										{constants.VIEW_BLOGS}
										<a target={"_blank"} href='https://saayahealth.com/blog'><span className="sh-color-counsellor"> {constants.CLICK_HERE_TXT}</span></a>
									</label>
								</div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  const { registering } = state.reg;
  const { whitelabel } = state.whitelabel;
  return {
    alert,
    registering,
    whitelabel,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    fetchWhitelabel: () => {
      dispatch(WhitelabelActions.fetchWhitelabel());
    },
    clearAlertActions: () => {
      dispatch(alertActions.clear());
    },
    alertError: (message) => {
      dispatch(alertActions.error(message));
    },
    registerUser: (user) => {
      dispatch(authActions.register(user));
    },
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Register)
);



// WEBPACK FOOTER //
// ./src/screens/Register/index.js